import { createAction, props } from '@ngrx/store';
import {
  DetectionDensity,
  Site,
  VolumeDensity
} from '../../models/site';
import { Update } from '@ngrx/entity';
import { SiteUserSettings } from '../../models/site-user-settings';

export const setSiteDensityHighlight = createAction('[Site] Site Density Highlight', props<{ density: DetectionDensity | VolumeDensity | undefined}>());
export const setSearchSiteText = createAction('[Site] Search Site', props<{ text: string | undefined}>());
export const selectSite = createAction('[Site] Select Site', props<{ siteId: string | undefined}>());

export const loadSites = createAction('[Site] Load Sites ', props<{ organizationId: string }>());
export const loadSitesSuccess = createAction('[Site] Load Sites success', props<{ sites: Site[] }>());
export const loadSitesFailure = createAction('[Site] Load Sites failure', props<{ error: any }>());

export const retrieveSite = createAction('[Site] Retrieve Site ', props<{ organizationId: string, siteId: string}>());
export const retrieveSiteSuccess = createAction('[Site] Retrieve Site Success', props<{ update: Update<any> }>());
export const retrieveSiteFailure = createAction('[Site] Retrieve Site failure', props<{ error: any }>());

export const activateAdvancedFeatures = createAction('[Site] Activate Advanced Features', props<{ organizationId: string, siteId: string}>());
export const activateAdvancedFeaturesSuccess = createAction('[Site] Activate Advanced Features Success', props<{ update: Update<any> }>());
export const activateAdvancedFeaturesFailure = createAction('[Site] Activate Advanced Features failure', props<{ error: any }>());

export const deactivateAdvancedFeatures = createAction('[Site] Deactivate Advanced Features', props<{ organizationId: string, siteId: string}>());
export const deactivateAdvancedFeaturesSuccess = createAction('[Site] Deactivate Advanced Features Success', props<{ update: Update<any> }>());
export const deactivateAdvancedFeaturesFailure = createAction('[Site] Deactivate Advanced Features failure', props<{ error: any }>());

export const updateSite = createAction('[Site] Update Site', props<{ update: Update<any> }>());


export const loadUserSettings = createAction(
  '[Site] Load User Settings',
  props<{
    organizationId: string;
    siteId: string;
  }>()
);

export const loadUserSettingsSuccess = createAction(
  '[Site] Load User Settings Success',
  props<{
    settings: SiteUserSettings;
  }>()
);

export const loadUserSettingsFailure = createAction(
  '[Site] Load User Settings Failure',
  props<{
    error: any;
  }>()
);


export const updateUserSettings = createAction(
  '[Site] Update User Settings',
  props<{
    organizationId: string;
    siteId: string;
    settings: SiteUserSettings;
  }>()
);

export const updateUserSettingsSuccess = createAction(
  '[Site] Update User Settings Success',
  props<{
    settings: SiteUserSettings;
  }>()
);

export const updateUserSettingsFailure = createAction(
  '[Site] Update User Settings Failure',
  props<{
    error: any;
  }>()
);
